import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import ScrollToTop from "./ScrollToTop";

import Navbar from './components/commons/Navbar';
import Footer from './components/commons/Footer';
import Homepage from './components/homepage/Homepage';
import About from "./components/about/About";

import Projects from "./components/projects/Projects";
import Projectdetail from "./components/projects/Projectdetail";
import Blueleaf from "./components/projects/Blueleaf";
import Sole from "./components/projects/Sole";
import Envirogreen from "./components/projects/Envirogreen";
import Postmaster from "./components/projects/Postmaster";
import Social from "./components/projects/Social";
import Arthur from "./components/projects/Arthurcashredesign";
import Arthurorig from "./components/projects/Arthurcash";
import Calvary from "./components/projects/Calvary";

import Skills from './components/skills/Skills';
import Resume from './components/resume/Resume'
import Contact from "./components/contact/Contact";
import MassNow from "./components/projects/MassNow";





import './App.scss';

class App extends Component {

  render() {
    return (
      <Router>
        <ScrollToTop>
          <React.Fragment>
            {/* <Navbar /> */}
            <Route exact path="/" component={Homepage} />
            <Route path="/about" component={About} />
            <Route path="/projects" component={Projects} />
            <Route path="/projectdetail" component={Projectdetail} />
            <Route path="/skills" component={Skills} />
            <Route path="/resume" component={Resume} />
            <Route path="/blueleaf" component={Blueleaf} />
            <Route path="/sole" component={Sole} />
            <Route path="/envirogreen" component={Envirogreen} />
            <Route path="/postmaster" component={Postmaster} />
            <Route path="/social" component={Social} />
            <Route path="/arthurcash" component={Arthur} />
            <Route path="/arthurorig" component={Arthurorig} />
            <Route path="/calvary" component={Calvary} />
            <Route path="/contact" component={Contact} />
            <Route path="/massnow" component={MassNow} />
            <Footer />
          </React.Fragment>
        </ScrollToTop>
      </Router>
    );
  }
  
}

export default App;
